var _rect, _rect2, _g, _ellipse, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse2, _path8, _ellipse3, _path9, _ellipse4, _path10, _rect11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOrgHealthLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 86,
    viewBox: "0 0 101 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 86,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    transform: "translate(-713 -421)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -24,
    width: 260,
    height: 200,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -79,
    y: -23,
    width: 258,
    height: 198,
    rx: 3,
    stroke: "#5D5CF5",
    strokeWidth: 2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3324,
    cy: 42.6594,
    rx: 38,
    ry: 53.5,
    transform: "rotate(-60 50.3324 42.6594)",
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 30.3681L57.4569 19.0508V66.4255H29.1875V30.3681Z",
    fill: "#9BB9FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4707,
    y: 32.2109,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4707,
    y: 42.2129,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.752,
    y: 32.2109,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0352,
    y: 32.2109,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.752,
    y: 42.2129,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0352,
    y: 42.2129,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4707,
    y: 51.6895,
    width: 3.14105,
    height: 6.84302,
    fill: "#F3F3F3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5234,
    y: 64.3145,
    width: 35.075,
    height: 3.6847,
    fill: "#7596E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1114 27.7385L59.3295 18.0009L59.3294 21.9482L26.112 31.4229L26.1114 27.7385Z",
    fill: "#7596E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7904 45.4649C73.7904 53.0248 67.6957 59.1513 60.1799 59.1513C52.6641 59.1513 46.5694 53.0248 46.5694 45.4649C46.5694 37.9049 52.6641 31.7784 60.1799 31.7784C67.6957 31.7784 73.7904 37.9049 73.7904 45.4649Z",
    fill: "#FFF6D1",
    stroke: "#7596E3",
    strokeWidth: 0.420052
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3203 41.7812V44.5767",
    stroke: "#2F2F2F",
    strokeWidth: 0.342769,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7676 44.7773V47.5728",
    stroke: "#2F2F2F",
    strokeWidth: 0.342769,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2715 44.7773V47.5728",
    stroke: "#2F2F2F",
    strokeWidth: 0.342769,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7676 44.7773L67.2714 44.7773",
    stroke: "#2F2F2F",
    strokeWidth: 0.342769,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.3898,
    cy: 37.7381,
    rx: 1.53824,
    ry: 1.54669,
    fill: "#F17105"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3891 39.6699C59.7918 39.6699 59.2188 39.9609 58.7964 40.4789C58.374 40.9968 58.1367 41.6994 58.1367 42.4319H62.6416C62.6416 41.6994 62.4042 40.9968 61.9818 40.4789C61.5594 39.9609 60.9865 39.6699 60.3891 39.6699Z",
    fill: "#F17105"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.1418,
    cy: 49.7186,
    rx: 1.53824,
    ry: 1.54669,
    fill: "#7596E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1411 51.6641C66.5437 51.6641 65.9708 51.9551 65.5484 52.473C65.126 52.991 64.8887 53.6935 64.8887 54.426H69.3935C69.3935 53.6935 69.1562 52.991 68.7338 52.473C68.3114 51.9551 67.7385 51.6641 67.1411 51.6641Z",
    fill: "#7596E3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6378,
    cy: 49.7186,
    rx: 1.53824,
    ry: 1.54669,
    fill: "#62B498"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6372 51.6504C53.0398 51.6504 52.4669 51.9414 52.0445 52.4593C51.6221 52.9773 51.3848 53.6798 51.3848 54.4123H55.8896C55.8896 53.6798 55.6523 52.9773 55.2299 52.4593C54.8075 51.9414 54.2346 51.6504 53.6372 51.6504Z",
    fill: "#62B498"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -4023.5,
    y: -2100.5,
    width: 22802,
    height: 4952,
    stroke: "white",
    strokeWidth: 51
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_80",
    x: -84,
    y: -28,
    width: 268,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_80",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrgHealthLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/org-health-logo.7c379910.svg";
export { ForwardRef as ReactComponent };